import { Alert, AlertProps } from '@utilitywarehouse/hearth-react';
import { CustomContentProps, useSnackbar } from 'notistack';
import { forwardRef } from 'react';

type Variant = 'info' | 'success' | 'error' | 'warning' | 'default';

const getColorScheme = (variant: Variant): AlertProps['colorScheme'] => {
  switch (variant) {
    case 'success':
      return 'positive';
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'info':
    case 'default':
    default:
      return 'info';
  }
};

const AlertSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, message, variant }, ref) => {
    const { closeSnackbar } = useSnackbar();

    return (
      <div ref={ref}>
        <Alert
          colorScheme={getColorScheme(variant)}
          text={message}
          onClose={() => closeSnackbar(id)}
        />
      </div>
    );
  }
);
export { AlertSnackbar };
